<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5511_121364)">
      <path
        d="M24.7174 12.7763C24.7174 11.9605 24.6513 11.1404 24.5102 10.3379H13.1914V14.9589H19.6731C19.4042 16.4492 18.5399 17.7676 17.2745 18.6054V21.6037H21.1414C23.4123 19.5137 24.7174 16.4272 24.7174 12.7763Z"
        fill="#4285F4"
      />
      <path
        d="M13.1903 24.5013C16.4267 24.5013 19.1561 23.4387 21.1447 21.6044L17.2777 18.606C16.2019 19.338 14.8129 19.7525 13.1947 19.7525C10.0641 19.7525 7.40966 17.6404 6.45724 14.8008H2.4668V17.8917C4.50391 21.9439 8.65309 24.5013 13.1903 24.5013Z"
        fill="#34A853"
      />
      <path
        d="M6.45395 14.8007C5.95128 13.3103 5.95128 11.6965 6.45395 10.2062V7.11523H2.46791C0.765906 10.506 0.765906 14.5009 2.46791 17.8916L6.45395 14.8007Z"
        fill="#FBBC04"
      />
      <path
        d="M13.1903 5.24966C14.9011 5.2232 16.5546 5.86697 17.7936 7.04867L21.2197 3.62262C19.0503 1.5855 16.171 0.465534 13.1903 0.500809C8.65309 0.500809 4.50391 3.05822 2.4668 7.11481L6.45283 10.2058C7.40084 7.36173 10.0597 5.24966 13.1903 5.24966Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_5511_121364">
        <rect width="24" height="24" fill="white" transform="translate(0.951172 0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>
